import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import APIRequest from "../../../Services/commonAPIConsumer";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { AppContext } from "../../../AppContext";
import DistributionListsSection from "./DistributionListsSection";

const isDL = (r) => {
  const val = r?.isDLGroup ?? r?.IsDLGroup ?? r?.isDL ?? r?.IsDL;
  return val === true || val === "true" || val === "True";
};
const getDLEmail = (r) => (r?.DLEmail || r?.dlEmail || r?.dlemail || "").trim();

const isDLRecipientRecord = (r) => isDL(r) && (!getDLEmail(r) || getDLEmail(r).toLowerCase() === (r.email || r.Email || r.Address || "").trim().toLowerCase());
const isDLMemberRecord = (r) => isDL(r) && Boolean(getDLEmail(r)) && getDLEmail(r).toLowerCase() !== (r.email || r.Email || r.Address || "").trim().toLowerCase();

const isDLDoc = (docItem, records = []) =>
  Boolean(
    docItem?.isRPDDL === true || docItem?.isRPDDL === "true" ||
    docItem?.IsRPDDL === true || docItem?.IsRPDDL === "true" ||
    docItem?.documentOptions?.isRPDDL === true || docItem?.documentOptions?.isRPDDL === "true" ||
    docItem?.documentOptions?.IsRPDDL === true || docItem?.documentOptions?.IsRPDDL === "true" ||
    docItem?.distributionLists?.length ||
    docItem?.documentOptions?.distributionLists?.length ||
    (docItem?.documentOptions?.recipients || records || []).some(isDLRecipientRecord)
  );

export default function TrackInteractivity({ item, selectedLanguage, timeZoneAbbrevation, timeZoneRef, applyTimeZoneToDisplay, handleRefreshTrackInterActivity, handleRefresh, handleEditReaderDetails, handlerUserActiveInactive, handleReceiptsAdd, lstDocumentsHistory, SortingOptionsPopupOpen, Downloaduserstatus, trackInteractivityDetails, TrackIntereactivityrowclickDta, setOpen, contactGroups = [], }) {
  const dlMemberSortRef = useRef({});
  const handleDLMemberSortChange = (docId, dlIdx, sortConfig, dlEmail) => {
    if (dlEmail) dlMemberSortRef.current[dlEmail.toLowerCase()] = sortConfig;
    dlMemberSortRef.current[dlIdx] = sortConfig;
  };
  const [docVersions, setDocVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [popupCurrentPage, setPopupCurrentPage] = useState(1);
  const [readersSearchInput, setReadersSearchInput] = useState("");
  const [expanded, setExpanded] = useState({});
  const [checkedEmails, setCheckedEmails] = useState({});

  const [localIsReaderStatistics, setLocalIsReaderStatistics] = useState(false);
  const [localActiveEmail, setLocalActiveEmail] = useState("");
  const [localTrackDocumentId, setLocalTrackDocumentId] = useState("");
  const [localTrackInteractivityData, setLocalTrackInteractivityData] = useState([]);
  const [localSearchPageNum, setLocalSearchPageNum] = useState("");
  const [localStatsLoading, setLocalStatsLoading] = useState(false);

  const handleOpenLocalReaderStats = async (email) => {
    setLocalActiveEmail(email);
    const targetDocId = selectedVersion ? selectedVersion.documentId : item.documentId;
    setLocalTrackDocumentId(targetDocId);
    setLocalIsReaderStatistics(true);
    setLocalSearchPageNum("");
    setLocalStatsLoading(true);
    try {
      const versions = await fetchVersions(selectedVersion);
      const activeVersion = (versions && Array.isArray(versions)) ? (versions.find(v => v.id === selectedVersion.id || (getVersionKey(v) != null && getVersionKey(v) === getVersionKey(selectedVersion))) || selectedVersion) : selectedVersion;
      const currentReaders = getEnrichedVersionReaders(activeVersion);
      const reader = currentReaders.find(r => (r.email || "").toLowerCase() === (email || "").toLowerCase());
      if (reader && reader.readCount === 0) {
        setLocalTrackInteractivityData([]);
        setLocalStatsLoading(false);
        return;
      }

      const targetVersionNum = getVersionNumber(activeVersion);
      const openRecords = (activeVersion?.openRecords || []).filter(
        (record) => getOpenRecordVersionNumber(record) === targetVersionNum
      );
      const userOpenRecordIds = openRecords.filter(record => {
        if (email) {
          return record.email && record.email.toLowerCase() === email.toLowerCase() && record.id;
        } else {
          return (!record.email || record.email === "") && record.id;
        }
      }).map(record => record.id).join(",");

      if (!userOpenRecordIds) {
        setLocalTrackInteractivityData([]);
        setLocalStatsLoading(false);
        return;
      }

      const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetStatisticsData}/${targetDocId}`;
      const params = new URLSearchParams();
      params.append("openRecordId", userOpenRecordIds);
      params.append("IsStats", "false");
      const url = `${baseUrl}?${params.toString()}`;
      const jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        window.location.href = "/maintenance";
        return;
      } else if (jsonDocs && Array.isArray(jsonDocs)) {
        setLocalTrackInteractivityData(jsonDocs);
      } else {
        setLocalTrackInteractivityData([]);
      }
    } catch (err) {
      console.error("Error fetching reader statistics:", err);
      setLocalTrackInteractivityData([]);
    } finally {
      setLocalStatsLoading(false);
    }
  };

  const handlecloseReaderStats = () => {
    setLocalIsReaderStatistics(false);
    setLocalActiveEmail("");
    setLocalTrackDocumentId("");
    setLocalTrackInteractivityData([]);
  };

  const onSearchHandler = (e) => { setLocalSearchPageNum(e.target.value); };

  useEffect(() => {
    if (!selectedVersion) {
      setCheckedEmails({});
      setExpanded({});
    }
  }, [selectedVersion]);

  useEffect(() => {
    setExpanded({});
  }, [item.modified]);

  const isCheckboxSelectionDisabled = () => {
    if (!docItem) return false;
    const isDocDisabled = docItem.documentOptions?.enabled === false && docItem.isPermanentExpire == false && docItem.isKilled == false;
    return isDocDisabled || docItem.canEditRPDRecords === false;
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    const checkable = filteredRecipients.filter(r => r.email != null && r.email !== "");
    const newChecked = { ...checkedEmails };
    checkable.forEach(r => { newChecked[r.email] = isChecked; });
    setCheckedEmails(newChecked);
  };

  const handleSingleCheckChange = (email) => { setCheckedEmails(prev => ({ ...prev, [email]: !prev[email] })); };

  const handleMultiActiveInactiveLocal = async (uStatus) => {
    const checkable = filteredRecipients.filter(r => r.email != null && r.email !== "");
    const checkedList = checkable.filter(r => checkedEmails[r.email] && r.status).map(r => ({ email: r.email, status: r.status }));

    let FinalSelectedReadersList = [];
    if (uStatus) {
      checkedList.forEach((element) => {
        if (element.status === "Banned") {
          FinalSelectedReadersList.push({
            docId: item.documentId,
            email: element.email,
          });
        }
      });
    } else {
      checkedList.forEach((element) => {
        if (element.status === "Active") {
          FinalSelectedReadersList.push({
            docId: item.documentId,
            email: element.email,
          });
        }
      });
    }

    const email = null;
    const url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_RecipientActiveInactive}/${item.documentId}/${uStatus}/${email}`;

    if (FinalSelectedReadersList.length !== 0) {
      try {
        if (setOpen) setOpen(true);
        const jsonDocs = await APIRequest.POSTSaveSettings(
          JSON.stringify(FinalSelectedReadersList),
          url
        );
        if (jsonDocs && jsonDocs === "Server maintenance") {
          window.location.href = "/maintenance";
          return;
        } else if (jsonDocs == 200) {
          await fetchVersions();
          const docIdx = lstDocumentsHistory.findIndex(d => d.documentId === item.documentId);
          if (docIdx !== -1) {
            await handleRefreshTrackInterActivity(item.documentId, null, docIdx);
          }
          if (typeof handleRefresh === "function") {
            handleRefresh(item.documentId);
          }
        }
      } catch (err) {
        console.error("Error updating statuses:", err);
      } finally {
        if (setOpen) setOpen(false);
      }
    }
    setCheckedEmails({});
  };

  const getTimeFormat = (seconds) => {
    var time = "00:00:00";
    if (seconds != null) {
      var sec = parseInt(seconds, 10);
      var hours = Math.floor(sec / 3600);
      var minutes = Math.floor((sec - hours * 3600) / 60);
      sec = sec - hours * 3600 - minutes * 60;
      if (hours < 10) hours = "0" + hours;
      if (minutes < 10) minutes = "0" + minutes;
      if (sec < 10) sec = "0" + sec;
      time = hours + ":" + minutes + ":" + sec;
    }
    return time;
  };

  const getVersionSizeAndPages = (version) => {
    if (!version) return { size: "0 KB", pages: 0 };
    let totalKB = 0;
    let validFound = false;
    if (version.inputFiles && version.inputFiles.length > 0) {
      version.inputFiles.forEach(file => {
        const sizeStr = file.fileSize?.toString().trim().toLowerCase();
        if (!sizeStr) return;
        const sizeValue = parseFloat(sizeStr);
        if (isNaN(sizeValue)) return;
        validFound = true;
        if (sizeStr.includes("mb")) totalKB += sizeValue * 1024;
        else if (sizeStr.includes("kb")) totalKB += sizeValue;
        else totalKB += sizeValue;
      });
    }
    const size = validFound ? (totalKB >= 1024 ? `${Math.round(totalKB / 1024)} MB` : `${Math.round(totalKB)} KB`) : "0 KB";
    const pages = version.pagesCount || version.pages || 0;
    return { size, pages };
  };

  const getVersionKey = (ver) => {
    if (!ver) return null;
    if (ver.versionNo != null) return ver.versionNo;
    if (ver.version != null) return ver.version;
    if (ver.versionNumber != null) return ver.versionNumber;
    if (ver.documentVersion != null) return ver.documentVersion;
    if (ver.documentOptions) {
      if (ver.documentOptions.versionNo != null) return ver.documentOptions.versionNo;
      if (ver.documentOptions.version != null) return ver.documentOptions.version;
      if (ver.documentOptions.versionNumber != null) return ver.documentOptions.versionNumber;
      if (ver.documentOptions.documentVersion != null) return ver.documentOptions.documentVersion;
    }
    return ver.id;
  };

  const fetchVersions = async (currentVersion = null) => {
    try {
      if (setOpen) setOpen(true);
      const url = `${process.env.REACT_APP_API}/docs/GetTrackInteractivityVersions/${item.documentId}`;
      const jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && Array.isArray(jsonDocs)) {
        const versions = jsonDocs;
        versions.sort((a, b) => (b.versionNumber || 0) - (a.versionNumber || 0));

        versions.forEach((ver) => {
          ver.securityLevel = ver.documentOptions.distRestriction ? 3 : ver.documentOptions.readerEmail ? 2 : 1;
          let totalKB = 0;
          let validFound = false;
          if (ver.inputFiles && ver.inputFiles.length > 0) {
            ver.inputFiles.forEach(file => {
              const sizeStr = file.fileSize?.toString().trim().toLowerCase();
              if (!sizeStr) return;
              const sizeValue = parseFloat(sizeStr);
              if (isNaN(sizeValue)) return;
              validFound = true;
              if (sizeStr.includes("mb")) totalKB += sizeValue * 1024;
              else if (sizeStr.includes("kb")) totalKB += sizeValue;
              else totalKB += sizeValue;
            });
          }
          ver.originalSizeFormatted = validFound ? (totalKB >= 1024 ? `${Math.round(totalKB / 1024)} MB` : `${Math.round(totalKB)} KB`) : "0 KB";
        });
        setDocVersions(versions);
        const targetVersion = currentVersion || selectedVersion;
        if (targetVersion) {
          const matchedVersion = versions.find(v => v.id === targetVersion.id || (getVersionKey(v) != null && getVersionKey(v) === getVersionKey(targetVersion)));
          if (matchedVersion) {
            setSelectedVersion(matchedVersion);
            return matchedVersion;
          }
        }
        return versions;
      }
    } catch (error) {
      console.error("Error fetching versions for track interactivity:", error);
    } finally {
      if (setOpen) setOpen(false);
    }
    return null;
  };

  useEffect(() => {
    fetchVersions();
  }, [item.documentId, item.versionNumber, item.modified]);

  const getOpenRecordVersionNumber = (record) => {
    if (!record) return 1;
    const num = record.versionNumber != null ? record.versionNumber : (record.versionNo != null ? record.versionNo : (record.verNum != null ? record.verNum : 1));
    return parseInt(num, 10) || 1;
  };

  const getReaderSecondsAndReadsForVersion = (version, email) => {
    if (!version) return { seconds: 0, reads: 0 };
    const versionNum = getVersionNumber(version);
    const openRecords = (version.openRecords || []).filter((record) => getOpenRecordVersionNumber(record) === versionNum);
    if (email == null || email === "") {
      const anonymousReads = openRecords.filter((emailList) => emailList.email == null && (emailList.event === "Opened" || emailList.event == null));
      const anonSeconds = anonymousReads.map((timeCalc) => timeCalc.activityTime || 0).reduce((accTime, val) => val + accTime, 0);
      return { seconds: anonSeconds, reads: anonymousReads.length };
    } else {
      const matchingReads = openRecords.filter(
        (emailList) =>
          emailList.email != null && (emailList.event === "Opened" || emailList.event == null) &&
          emailList.email.toString().toLowerCase() === email.toString().toLowerCase()
      );
      const totalSeconds = matchingReads.map((timeCalc) => timeCalc.activityTime || 0).reduce((accTime, val) => val + accTime, 0);
      return { seconds: totalSeconds, reads: matchingReads.length };
    }
  };

  const getVersionNumber = (ver) => {
    const key = getVersionKey(ver);
    if (key == null) return 0;
    const num = parseInt(key, 10);
    return isNaN(num) ? 0 : num;
  };

  const getEnrichedVersionReaders = (currentVersion = null) => {
    const activeVersionNumber = currentVersion || selectedVersion;
    if (!activeVersionNumber) return [];
    let recipients = JSON.parse(JSON.stringify(activeVersionNumber.documentOptions?.recipients || []));
    const targetVersionNum = getVersionNumber(activeVersionNumber);
    const openRecords = (activeVersionNumber.openRecords || []).filter((record) => getOpenRecordVersionNumber(record) === targetVersionNum);

    const latestVersionNum = Math.max(...docVersions.map(v => getVersionNumber(v)), 0);
    const isLatestVersion = activeVersionNumber && getVersionNumber(activeVersionNumber) === latestVersionNum;
    const prevVersion = isLatestVersion ? docVersions.filter(v => getVersionNumber(v) < latestVersionNum).sort((a, b) => getVersionNumber(b) - getVersionNumber(a))[0] : null;

    const anonymousOpens = openRecords.filter((emailList) => emailList.email == null && (emailList.event === "Opened" || emailList.event == null));
    const anonStats = getReaderSecondsAndReadsForVersion(activeVersionNumber, null);
    let totalAnonTime = "00:00:00";
    let finalAnonReads = anonStats.reads;
    totalAnonTime = getTimeFormat(anonStats.seconds);

    if (anonymousOpens.length > 0) {
      const anonOpenedTime = anonymousOpens[0].opened;
      let hasNullEmail = false;
      recipients.forEach((recp) => {
        if (recp.email === null || recp.email === "") {
          recp.openedTime = anonOpenedTime;
          recp.totalTime = totalAnonTime;
          recp.readCount = finalAnonReads;
          hasNullEmail = true;
        }
      });
      if (!hasNullEmail) {
        recipients.push({ email: null, firstName: "", lastName: "", mobileCountryCode: "", mobileNumber: "", openedTime: anonOpenedTime, totalTime: totalAnonTime, readCount: finalAnonReads, checked: false, });
      }
    }
    const matchedDetail = trackInteractivityDetails?.find(d => d.docId === item.documentId);
    const sortedRecords = matchedDetail?.records || [];

    recipients.forEach((recp) => {
      const liveRecp = item?.documentOptions?.recipients?.find(r => r.email && recp.email && r.email.toLowerCase() === recp.email.toLowerCase());
      if (liveRecp) {
        recp.enabled = liveRecp.enabled;
        recp.status = liveRecp.status;
      }

      if (recp.email != null && recp.email !== "") {
        const matchingOpens = openRecords.filter((emailList) => emailList.email != null && (emailList.event === "Opened" || emailList.event == null) && emailList.email.toString().toLowerCase() === recp.email.toString().toLowerCase());
        if (matchingOpens.length > 0) {
          recp.openedTime = matchingOpens[0].opened || "";
        } else {
          recp.openedTime = "";
        }

        const stats = getReaderSecondsAndReadsForVersion(activeVersionNumber, recp.email);
        recp.readCount = stats.reads;
        recp.totalTime = getTimeFormat(stats.seconds);
      }
      const matchedRecord = sortedRecords.find(r => (r.email && recp.email && r.email.toLowerCase() === recp.email.toLowerCase()) || (!r.email && !recp.email));
      if (matchedRecord) {
        recp.daysFirstAuthrized = matchedRecord.daysFirstAuthrized;
        recp.daysSinceFirstView = matchedRecord.daysSinceFirstView;
        recp.daysSinceLastView = matchedRecord.daysSinceLastView;
        if (matchedRecord.vote !== undefined && matchedRecord.vote !== null) {
          recp.vote = matchedRecord.vote;
        }
        if (matchedRecord.code !== undefined && matchedRecord.code !== null) {
          recp.code = matchedRecord.code;
        }
        if (matchedRecord.dlEmail !== undefined) {
          recp.dlEmail = matchedRecord.dlEmail;
        }
        if (matchedRecord.isDLGroup !== undefined) {
          recp.isDLGroup = matchedRecord.isDLGroup;
        }
      }
      const printCountFromRecords = matchedRecord ? matchedRecord.printCount : undefined;
      const printMatch = openRecords.find((or) => or.email && recp.email && or.email.toLowerCase() === recp.email.toLowerCase());
      recp.printCount = (printCountFromRecords !== undefined && printCountFromRecords !== null) ? printCountFromRecords : (printMatch ? printMatch.printCount || 0 : 0);
      recp.checked = recp.email ? !!checkedEmails[recp.email] : false;

      const prevVersionRecp = prevVersion?.documentOptions?.recipients?.find(r =>
        r.email && recp.email && r.email.toLowerCase() === recp.email.toLowerCase()
      );
      const getParsedTime = (timeStr) => {
        if (!timeStr) return 0;
        const d = new Date(timeStr);
        return isNaN(d.getTime()) ? 0 : d.getTime();
      };
      const timeA = getParsedTime(recp.eDisclosureTime);
      const timeB = prevVersionRecp ? getParsedTime(prevVersionRecp.eDisclosureTime) : 0;
      const hasAgreedOnCurrentVersion = !prevVersion ||
        timeA === 0 ||
        !prevVersionRecp ||
        timeA !== timeB;
      recp.hasAgreedOnCurrentVersion = hasAgreedOnCurrentVersion;
    });
    sortedRecords.forEach((sr) => {
      if (sr && sr.email && !recipients.some((r) => r && r.email && r.email.toLowerCase() === sr.email.toLowerCase())) {
        recipients.push({ ...sr });
      }
    });

    if (sortedRecords.length > 0) {
      recipients.sort((a, b) => {
        const indexA = sortedRecords.findIndex(r => {
          const rEmail = (r.email || "").toLowerCase().trim();
          const aEmail = (a.email || "").toLowerCase().trim();
          return rEmail === aEmail;
        });
        const indexB = sortedRecords.findIndex(r => {
          const rEmail = (r.email || "").toLowerCase().trim();
          const bEmail = (b.email || "").toLowerCase().trim();
          return rEmail === bEmail;
        });
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
    }

    return recipients;
  };

  const docItem = lstDocumentsHistory.find(d => d.documentId === item.documentId);
  const enrichedRecipients = getEnrichedVersionReaders();
  const isDL = isDLDoc(item, enrichedRecipients, contactGroups);
  const baseReaders = isDL ? enrichedRecipients.filter(r => !isDLRecipientRecord(r) && !isDLMemberRecord(r)) : enrichedRecipients;
  let filteredRecipients = baseReaders;
  if (readersSearchInput) {
    const q = readersSearchInput.toLowerCase().trim();
    filteredRecipients = baseReaders.filter(r => {
      const email = (r.email || "").toLowerCase();
      const first = (r.firstName || "").toLowerCase();
      const last = (r.lastName || "").toLowerCase();
      const mob = (r.mobileNumber || "").toLowerCase();
      return email.includes(q) || first.includes(q) || last.includes(q) || mob.includes(q);
    });
  }

  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredRecipients.length / itemsPerPage);
  const paginatedRecipients = filteredRecipients.slice((popupCurrentPage - 1) * itemsPerPage, popupCurrentPage * itemsPerPage);

  return (
    <div>
      {/* Versions Table */}
      <div className="table-responsive text-start scrollable-content mt-15p">
        <table className="fold-table table align-middle" cellPadding="0" cellSpacing="0">
          <thead className="bg-lightblue">
            <tr>
              <th>{selectedLanguage.LstLanguageCodes.UI_versionNo}</th>
              <th>{selectedLanguage.LstLanguageCodes.UI_OriginalSize}/{selectedLanguage.LstLanguageCodes.UI_Pages}</th>
              <th>{selectedLanguage.LstLanguageCodes.UI_UpdatedSize}/{selectedLanguage.LstLanguageCodes.UI_Pages}</th>
              <th>{selectedLanguage.LstLanguageCodes.UI_UpdatedBy}</th>
              <th>{selectedLanguage.LstLanguageCodes.UI_UpdatedTime} ({timeZoneAbbrevation.current})</th>
              <th className="text-center">{selectedLanguage.LstLanguageCodes.UI_ReadersSnapshot}</th>
            </tr>
          </thead>
          <tbody>
            {docVersions.map((version, vIdx, vArr) => {
              const verNum = "V" + (vArr.length - vIdx);
              return (
                <tr key={version.id || vIdx} className="view borderrow font-14">
                  <td>
                    <a style={{ color: '#3045c0fc', cursor: "pointer" }} className="ms-1"
                      onClick={async () => {
                        setPopupCurrentPage(1);
                        setReadersSearchInput("");
                        const currentVersionNumber = await fetchVersions(version);
                        setSelectedVersion(currentVersionNumber || version);
                      }}>
                      {verNum}
                    </a>
                  </td>
                  {(() => {
                    const isOldest = vIdx === vArr.length - 1;
                    const curInfo = getVersionSizeAndPages(version);
                    if (isOldest) {
                      return (
                        <>
                          <td>{curInfo.size} / {curInfo.pages}</td>
                          <td>N/A</td>
                        </>
                      );
                    } else {
                      const prevInfo = getVersionSizeAndPages(vArr[vIdx + 1]);
                      return (
                        <>
                          <td>{prevInfo.size} / {prevInfo.pages}</td>
                          <td>{curInfo.size} / {curInfo.pages}</td>
                        </>
                      );
                    }
                  })()}
                  <td>{version.modifiedBy || version.createdBy || "-"}</td>
                  <td>
                    {version.modified != null
                      ? moment.utc(applyTimeZoneToDisplay(new Date(version.modified), timeZoneRef.current)).format("DD/MM/YYYY HH:mm")
                      : moment.utc(applyTimeZoneToDisplay(new Date(version.created), timeZoneRef.current)).format("DD/MM/YYYY HH:mm")}
                  </td>
                  <td className="text-center">
                    <a style={{ color: '#3045c0fc', cursor: "pointer" }} className="ms-1"
                      onClick={async () => {
                        setPopupCurrentPage(1);
                        setReadersSearchInput("");
                        const currentVersionNumber = await fetchVersions(version);
                        setSelectedVersion(currentVersionNumber || version);
                      }}>
                      {selectedLanguage.LstLanguageCodes.UI_ViewInfo}
                    </a>
                  </td>
                </tr>
              );
            })
            }
          </tbody>
        </table>
      </div>

      {/* Version Details Overlay Popup Modal */}
      {selectedVersion && (() => {
        const versionIdx = docVersions.length - docVersions.findIndex(v => v.id === selectedVersion.id || (getVersionKey(v) != null && getVersionKey(v) === getVersionKey(selectedVersion)));

        return (
          <div className="modalCus documentversion-history" id="myModal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered modal-customelg" style={{ maxWidth: '95vw', width: '95vw' }}>
              <div className="modal-content">

                {/* Header */}
                <div className="card-body pt-1 pb-0">
                  {/* Document Name bar */}
                  <div className="row">
                    <div className="input-group field mt-1 res-nowwrap d-flex align-items-center justify-content-between flex-wrap gap-2" style={{ padding: '0 15px' }}>
                      <p className="fw-bold text-word-break mb-0 font-17">
                        {selectedLanguage.LstLanguageCodes.UI_DocumentName}: {selectedVersion.fileName} - V{versionIdx}
                      </p>

                      <div className="d-flex align-items-center flex-wrap gap-2">
                        {!isDL && enrichedRecipients.length > 1 && (
                          <input
                            type="search"
                            className="search-Reader-FirstNameLastName"
                            style={{ height: "32px", fontSize: "12px", padding: "4px 8px", width: "240px", border: "1px solid #ced4da", borderRadius: "4px" }}
                            placeholder="Search reader email, name..."
                            value={readersSearchInput}
                            onChange={(e) => {
                              setReadersSearchInput(e.target.value);
                              setPopupCurrentPage(1);
                            }}
                            onBlur={(e) => { setReadersSearchInput(e.target.value.trim()); }}
                          />
                        )}

                        <div className="font-w600 mb-0 d-flex align-items-center">
                          {!isDL && Object.values(checkedEmails).some(val => val === true) && (
                            <span className="" style={{ marginRight: '5px' }}>
                              <input className="btn btn-outline-danger checked-btn track-btns" onClick={() => handleMultiActiveInactiveLocal(false)} type="button" value={selectedLanguage.LstLanguageCodes.UI_BanSelected} />
                              <input className="btn btn-outline-success checked-btn track-btns" onClick={() => handleMultiActiveInactiveLocal(true)} type="button" value={selectedLanguage.LstLanguageCodes.UI_ActivateSelected} />
                            </span>
                          )}
                          {!isDL && selectedVersion.securityLevel === 3 && !(docItem && (docItem.isKilled == true || docItem.isPermanentExpire == true)) && (
                            <span className={docItem && docItem.isKilled == true ? "material-icons top3 disabled" : "material-icons top3"}
                              title={selectedLanguage.LstLanguageCodes.UI_AddAutherizedReaders}
                              style={{ fontSize: "26px", marginRight: "4px", marginLeft: "10px", fontWeight: 800, cursor: "pointer", height: "34px" }}
                              onClick={(e) => handleReceiptsAdd(item.documentId)}
                            >
                              person_add
                            </span>
                          )}
                          {!isDL && (
                            <img
                              src="assets/img/icons/sort.png"
                              className={docItem && docItem.canEditRPDRecords == false ? "disabled" : ""}
                              alt="Sort"
                              style={{ cursor: "pointer", height: "39px", marginRight: "5px", }}
                              onClick={() => {
                                if (docItem && docItem.canEditRPDRecords !== false) {
                                  SortingOptionsPopupOpen(item.documentId);
                                }
                              }}
                            />
                          )}
                          <img src="assets/img/icons/download.png" className={`h-30p ${docItem && docItem.canEditRPDRecords == false ? "disabled" : ""}`} alt="Download"
                            title={selectedLanguage.LstLanguageCodes.UI_DownloadReaderlist} style={{ marginRight: "5px", height: "24px", cursor: "pointer", }}
                            onClick={() => {
                              if (docItem && docItem.canEditRPDRecords !== false) {
                                Downloaduserstatus(item.documentId, versionIdx, selectedVersion, enrichedRecipients, dlMemberSortRef.current);
                              }
                            }}
                          />
                        </div>
                        <button type="button" className="btn btn-outline-danger modalclose download" onClick={() => setSelectedVersion(null)} style={{ marginLeft: "10px" }}>
                          <span className="material-icons font-20">highlight_off</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal Body */}
                <div className="card-body pt-0 scrollable-content" style={{ maxHeight: '60vh', overflowY: "auto", overflowX: "hidden", display: "block", paddingRight: "3px", marginRight: "10px", marginTop: "15px" }}>
                  {/* Distribution Lists Section if isRPDDL is true */}
                  {isDL && (
                    <DistributionListsSection
                      documentId={selectedVersion?.documentId || item.documentId}
                      isRPDDL={true}
                      initialDLList={selectedVersion?.distributionLists || item.distributionLists || item.documentOptions?.distributionLists}
                      recipients={enrichedRecipients && enrichedRecipients.length > 0 ? enrichedRecipients : (selectedVersion?.documentOptions?.recipients || item?.documentOptions?.recipients || item?.records || [])}
                      selectedLanguage={selectedLanguage}
                      timeZoneAbbrevation={timeZoneAbbrevation}
                      timeZoneRef={timeZoneRef}
                      applyTimeZoneToDisplay={applyTimeZoneToDisplay}
                      dateFormatValueUpper="DD/MM/YYYY"
                      onOpenReaderStats={handleOpenLocalReaderStats}
                      searchQuery=""
                      canEdit={!isCheckboxSelectionDisabled()}
                      handlerUserActiveInactive={handlerUserActiveInactive}
                      handleRefreshTrackInterActivity={handleRefreshTrackInterActivity}
                      setOpen={setOpen}
                      contactGroups={contactGroups}
                      onMemberSortChange={handleDLMemberSortChange}
                    />
                  )}

                  {/* Individual Readers Section Header if isRPDDL is true */}
                  {isDL && (
                    <div className="d-flex align-items-center justify-content-between mb-2 mt-4 individual-readers-header">
                      <h6 className="fw-bold mb-0 d-flex align-items-center text-dark font-14">
                        <span>{selectedLanguage?.LstLanguageCodes?.UI_IndividualReaders || "Individual Readers"}</span>
                        <span
                          className="badge rounded-pill bg-light text-secondary ms-2 border"
                          style={{ fontSize: "11px", fontWeight: "700" }}
                        >
                          {filteredRecipients.length}
                        </span>
                      </h6>
                      <div className="manage-sortby-text d-flex align-items-center flex-shrink-0 individual-readers-controls">
                        {Object.values(checkedEmails).some(val => val === true) && (
                          <span className="" style={{ marginRight: '5px' }}>
                            <input className="btn btn-outline-danger checked-btn track-btns" onClick={() => handleMultiActiveInactiveLocal(false)} type="button" value={selectedLanguage.LstLanguageCodes.UI_BanSelected} />
                            <input className="btn btn-outline-success checked-btn track-btns" onClick={() => handleMultiActiveInactiveLocal(true)} type="button" value={selectedLanguage.LstLanguageCodes.UI_ActivateSelected} />
                          </span>
                        )}
                        {baseReaders && baseReaders.length > 1 && (
                          <input
                            type="search"
                            className="search-Reader-FirstNameLastName mr-12p"
                            style={{ height: "32px", fontSize: "12px", padding: "4px 8px", width: "240px", border: "1px solid #ced4da", borderRadius: "4px", marginBottom: "0" }}
                            placeholder={selectedLanguage?.LstLanguageCodes?.UI_EnterEmailOrFirstNameOrLastNameToSearch || "Search reader email, name..."}
                            title={selectedLanguage?.LstLanguageCodes?.UI_EnterEmailOrFirstNameOrLastNameToSearch || "Search reader email, name..."}
                            value={readersSearchInput}
                            onChange={(e) => {
                              setReadersSearchInput(e.target.value);
                              setPopupCurrentPage(1);
                            }}
                            onBlur={(e) => { setReadersSearchInput(e.target.value.trim()); }}
                          />
                        )}
                        {selectedVersion.securityLevel === 3 && !(docItem && (docItem.isKilled == true || docItem.isPermanentExpire == true)) && (
                          <label className="font-w600 mb-0 d-flex align-items-center">
                            <span
                              className={docItem && docItem.isKilled == true ? "material-icons top3 disabled" : "material-icons top3"}
                              title={selectedLanguage.LstLanguageCodes.UI_AddAutherizedReaders}
                              style={{ fontSize: "26px", marginRight: "4px", marginLeft: "10px", fontWeight: 800, cursor: "pointer", height: "34px" }}
                              onClick={(e) => handleReceiptsAdd(item.documentId)}
                            >
                              person_add
                            </span>
                          </label>
                        )}
                        <img
                          src="assets/img/icons/sort.png"
                          className={docItem && docItem.canEditRPDRecords == false ? "disabled" : ""}
                          alt="Sort"
                          style={{ cursor: "pointer", height: "39px", marginRight: "5px" }}
                          onClick={() => {
                            if (docItem && docItem.canEditRPDRecords !== false) {
                              SortingOptionsPopupOpen(item.documentId);
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="table-responsive res-card">
                    <table className="fold-table table align-middle mb-0" cellPadding="0" cellSpacing="0">
                      <thead className="bg-lightblue">
                        <tr>
                          <th style={{ width: '2%' }}></th>
                          <th style={{ width: '2%' }} className="text-center">
                            {(() => {
                              const checkable = filteredRecipients.filter(r => r.email != null && r.email !== "");
                              const isAllChecked = checkable.length > 0 && checkable.every(r => checkedEmails[r.email]);
                              const isAllDisabled = isCheckboxSelectionDisabled() || checkable.length === 0;

                              return (
                                <div className="checkbox res-ml" style={{ cursor: isAllDisabled ? "not-allowed" : "pointer", pointerEvents: "auto", }}>
                                  <label style={{ position: "relative", cursor: isAllDisabled ? "not-allowed" : "pointer", pointerEvents: "auto", }} className="p-0 mb-0">
                                    <input type="checkbox" checked={checkable.length > 0 && isAllChecked} disabled={isAllDisabled} onChange={handleSelectAllChange} />
                                    <span className="cr" style={{ cursor: isAllDisabled ? "not-allowed" : "pointer", }}>
                                      <i className="cr-icon material-icons">check</i>
                                    </span>
                                  </label>
                                </div>
                              );
                            })()}
                          </th>
                          <th style={{ width: '25%' }}>{selectedLanguage.LstLanguageCodes.UI_Adress}</th>
                          <th style={{ width: '13%' }}>{selectedLanguage.LstLanguageCodes.UI_FirstName}</th>
                          <th style={{ width: '13%' }}>{selectedLanguage.LstLanguageCodes.UI_LastName}</th>
                          <th style={{ width: '13%' }}>{selectedLanguage.LstLanguageCodes.UI_Mobile}</th>
                          <th style={{ width: '15%' }}>{selectedLanguage.LstLanguageCodes.UI_FirstRead} ({timeZoneAbbrevation.current})</th>
                          <th style={{ width: '8%' }} className="text-center">{selectedLanguage.LstLanguageCodes.UI_Reads}</th>
                          <th style={{ width: '8%' }} className="text-center">{selectedLanguage.LstLanguageCodes.UI_TotalMinutes}</th>
                          <th style={{ width: '8%' }} className="text-center">{selectedLanguage.LstLanguageCodes.UI_Vote}</th>
                          <th style={{ width: '10%' }} className="text-center">{selectedLanguage.LstLanguageCodes.UI_Status}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedRecipients.length === 0 ? (
                          <tr>
                            <td colSpan={10}>
                              <div className="no-record mt-n1 d-flex align-items-center justify-content-center">
                                <span className="material-icons">report_problem</span>
                                <span className="">{selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          paginatedRecipients.map((recp, rIdx) => {
                            const globalIdx = filteredRecipients.findIndex(r => r.email === recp.email);
                            const isExpanded = expanded[globalIdx.toString()] || false;
                            const toggleRowExpanded = () => {
                              const newExpanded = !isExpanded;
                              setExpanded(prev => ({ ...prev, [globalIdx.toString()]: newExpanded }));
                              if (newExpanded && recp.email) {
                                if (TrackIntereactivityrowclickDta) {
                                  TrackIntereactivityrowclickDta(item.documentId, recp.email);
                                }
                                if (handleRefreshTrackInterActivity) {
                                  handleRefreshTrackInterActivity(item.documentId);
                                }
                              }
                            };

                            return (
                              <React.Fragment key={recp.email || rIdx}>
                                <tr className="view borderrow font-14 pointer" onClick={toggleRowExpanded}>
                                  <td className="expand">
                                    <div className="d-flex align-items-center gap-1">
                                      <span className="material-icons font-16 expand-icon">
                                        {isExpanded ? 'expand_more' : 'chevron_right'}
                                      </span>

                                    </div>
                                  </td>
                                  <td className="text-center align-middle" onClick={(e) => e.stopPropagation()}>
                                    {recp.email != null && recp.email !== "" && (
                                      <div className={`checkbox mt-n5p marginTop8 res-ml-n8 ${isCheckboxSelectionDisabled() ? "disabled" : ""}`}>
                                        <label className="p-0 mb-0" style={{ cursor: isCheckboxSelectionDisabled() ? "not-allowed" : "pointer" }}>
                                          <input type="checkbox" checked={!!checkedEmails[recp.email]} disabled={isCheckboxSelectionDisabled()} onChange={() => handleSingleCheckChange(recp.email)} />
                                          <span className="cr">
                                            <i className="cr-icon material-icons">check</i>
                                          </span>
                                        </label>
                                      </div>
                                    )}
                                  </td>
                                  <td><span>{recp.email || "Anonymous"}</span>
                                    {recp.email !== null && recp.email !== "" && docItem && docItem.isKilled === false && docItem.isPermanentExpire === false && docItem.canEditRPDRecords !== false && (
                                      <span className={item.isKilled == true || item?.canEditRPDRecords == false ? "material-icons top3 disabled" : "material-icons top3"}
                                        title={selectedLanguage.LstLanguageCodes.UI_EditReaderDetails} style={{ marginLeft: "4pt", fontWeight: 100, cursor: "pointer", fontSize: "18px", }}
                                        onClick={(e) => handleEditReaderDetails(e, item.documentId, recp.id, recp)}>
                                        edit
                                      </span>
                                    )}
                                  </td>
                                  <td>{recp.firstName}</td>
                                  <td>{recp.lastName}</td>
                                  <td>{recp.mobileNumber ? (recp.mobileCountryCode ? `${recp.mobileCountryCode} ` : "") + recp.mobileNumber : ""}</td>
                                  <td>{recp.openedTime ? moment.utc(applyTimeZoneToDisplay(new Date(recp.openedTime), timeZoneRef.current)).format("DD/MM/YYYY HH:mm") : ""}</td>
                                  <td className="text-center">{recp.readCount}</td>
                                  <td className="text-center">{recp.totalTime}</td>
                                  <td className="text-center">
                                    {recp.vote === 1 ? (
                                      <span className="material-icons colorGreen font-20">thumb_up_alt</span>
                                    ) : recp.vote === 0 ? (
                                      <span className="material-icons colorRed font-20">thumb_down_alt</span>
                                    ) : "-"}
                                  </td>
                                  <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                    {recp.email !== null && recp.email !== "" && (
                                      recp.enabled === true ? (
                                        <button style={{ padding: "5px 18px 5px 18px", }} type="button"
                                          className={((item.isKilled == false && item.isPermanentExpire == false && item?.canEditRPDRecords !== false)) ? "btn btn-outline-success track-btn" : "btn btn-outline-success disabled track-btn"}
                                          onClick={(e) => item.isKilled == false && item.isPermanentExpire == false ? handlerUserActiveInactive(e, false, item.documentId, recp.email) : undefined}>
                                          {selectedLanguage.LstLanguageCodes.UI_Active}
                                        </button>
                                      ) : (
                                        <div title={recp.status === "Pause" ? "The Reader status cannot be altered while the RPD is in an Expired state." : ""} style={{ cursor: recp.status == "Pause" ? "not-allowed" : "pointer" }}>
                                          <button style={{ padding: recp.status == "Pause" && item.documentOptions.enabled == false ? "5px 20px 5px 20px" : "5px 13px", cursor: ((recp.status == "Pause")) ? 'not-allowed' : 'pointer' }} type="button"
                                            className={((recp.status == "Pause" && item.documentOptions.enabled == false) || item?.canEditRPDRecords == false) ? "btn btn-outline-danger Pause disabled track-btn" : recp.status == "Banned" && item.documentOptions.enabled == false || item?.canEditRPDRecords == false ? "btn  btn-outline-danger BannedBtn disabled track-btn" : item.isKilled == false && item.isPermanentExpire == false && item?.canEditRPDRecords !== false ? "btn btn-outline-danger" : "btn btn-outline-danger disabled track-btn"}
                                            onClick={(e) => item.isKilled == false && item.isPermanentExpire == false ? handlerUserActiveInactive(e, true, item.documentId, recp.email) : undefined}>
                                            {recp.email != "" && recp.email != null && recp.email != undefined && (recp.status == "Pause" ? selectedLanguage.LstLanguageCodes.UI_Pause : selectedLanguage.LstLanguageCodes.UI_Banned)}
                                          </button>
                                        </div>
                                      )
                                    )}
                                  </td>
                                </tr>

                                {/* Expanded Row */}
                                {isExpanded && (
                                  <tr className="fold open">
                                    <td colSpan={11}>
                                      <div className="fold-content" style={{ padding: "0em", boxShadow: "none" }}>
                                        <div className="row mx-0 cardborder align-items-start">

                                          {/* Left details */}
                                          <div className="col-sm-12 col-md-5 ps-1">
                                            <div className="d-flex flex-column">
                                              <h6 className="font-w600 daysince mb-0 text-dec w-auto">
                                                <span className="material-icons me-1">date_range</span>
                                                <span>{selectedLanguage.LstLanguageCodes.UI_DaysSince}</span>
                                              </h6>

                                              <div className="d-flex align-itmes-center py-0 tracktext">
                                                <div className="d-flex align-items-center">
                                                  <span className="font-w400">
                                                    {selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstAuthorized}:
                                                  </span>
                                                  <span className="ms-2" style={{ fontWeight: '600' }}>
                                                    {recp.daysFirstAuthrized >= 1 ? recp.daysFirstAuthrized : 0}
                                                  </span>
                                                </div>
                                                <div className="d-flex align-items-center mx-3">
                                                  <span className="font-w400">
                                                    {selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstSActivity}:
                                                  </span>
                                                  <span className="ms-2" style={{ fontWeight: '600' }}>
                                                    {recp.daysSinceFirstView >= 1 ? recp.daysSinceFirstView : 0}
                                                  </span>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                  <span className="font-w400">
                                                    {selectedLanguage.LstLanguageCodes.UI_DaysSinceLastActivity}:
                                                  </span>
                                                  <span className="ms-2" style={{ fontWeight: '600' }}>
                                                    {recp.daysSinceLastView >= 1 ? recp.daysSinceLastView : 0}
                                                  </span>
                                                </div>
                                              </div>

                                              {recp.email !== "" && recp.email != undefined && (
                                                <div style={{ fontWeight: '400' }} className="d-flex align-items-center">
                                                  <span style={{ color: '#d21513' }} className="material-icons me-1">stacked_bar_chart</span>
                                                  <span>{selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbyPage}:</span>
                                                  <a style={{ color: '#3045c0fc', cursor: "pointer" }} className="ms-1" onClick={() => handleOpenLocalReaderStats(recp.email)}>
                                                    {selectedLanguage?.LstLanguageCodes?.UI_View}
                                                  </a>
                                                </div>
                                              )}

                                              <div className="text-start d-flex tracktext">
                                                <span className="font-w400">
                                                  {selectedLanguage.LstLanguageCodes.UI_PrintCount}:
                                                </span>
                                                <span className="ms-2 font-w600">
                                                  {recp.printCount !== undefined ? recp.printCount : 0}
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Right details */}
                                          <div className="col-sm-12 col-md-7 borderleft-cus text-start ps-4 h-100 font-13 max-h-180 text-secondary-color scrollable-content border-top-sm mt-sm-2 pt-sm-2">
                                            <div className="d-flex flex-column" style={{ gap: "6px" }}>
                                              {recp.eDisclosureAgreed !== undefined ? (
                                                <>
                                                  <div className="col-sm-12 text-start d-flex tracktext">
                                                    <span className="font-w400 w-38">
                                                      {selectedLanguage.LstLanguageCodes.UI_EDisclosureStatus} {":"}
                                                    </span>
                                                    <span className="ms-1" style={{ fontWeight: '600' }}>
                                                      {recp.eDisclosureAgreed !== undefined ? (
                                                        recp.eDisclosureAgreed !== null && recp.hasAgreedOnCurrentVersion ? (
                                                          <>
                                                            {recp.eDisclosureAgreed
                                                              ? selectedLanguage.LstLanguageCodes.UI_Agreed
                                                              : selectedLanguage.LstLanguageCodes.UI_DisAgreed}
                                                            &nbsp;[
                                                            {moment.utc(applyTimeZoneToDisplay(new Date(recp.eDisclosureTime), timeZoneRef.current)).format("DD/MM/YYYY HH:mm")}
                                                            &nbsp;{timeZoneAbbrevation.current}]
                                                          </>
                                                        ) : ""
                                                      ) : ""}
                                                    </span>
                                                  </div>
                                                </>
                                              ) : ""}

                                              {item.securityLevel !== 1 && recp.email != null && recp.email !== "" && (
                                                <div className="d-flex tracktext pt-0">
                                                  <span className="font-w400 w-38">
                                                    {selectedLanguage?.LstLanguageCodes?.UI_ReferenceTxt || "Reference"}:
                                                  </span>
                                                  <span className="ms-1 font-w600">
                                                    {recp.reference || ""}
                                                  </span>
                                                </div>
                                              )}

                                              {recp.email != null && recp.email !== "" && (
                                                <div className="d-flex tracktext pt-0">
                                                  <span className="font-w400 w-38">
                                                    {selectedLanguage?.LstLanguageCodes?.UI_SendVerificationCode || "Send verification code"}:
                                                  </span>
                                                  <span className="ms-1 font-w600">
                                                    {recp.authType ? (
                                                      recp.authType === "both"
                                                        ? `${selectedLanguage.LstLanguageCodes.UI_Email}, ${selectedLanguage.LstLanguageCodes.UI_Text}`
                                                        : recp.authType.charAt(0).toUpperCase() + recp.authType.slice(1)
                                                    ) : ""}
                                                  </span>
                                                </div>
                                              )}

                                              {recp.email != null && recp.email !== "" && (
                                                <div className="d-flex tracktext pt-0">
                                                  <span className="font-w400 w-38">
                                                    {selectedLanguage?.LstLanguageCodes?.UI_MaxAllowedPrints || "Max Allowed Prints"}:
                                                  </span>
                                                  <span className="ms-1 font-w600">
                                                    {(recp.maxPrintsPerReader !== undefined && recp.maxPrintsPerReader > 0) ? recp.maxPrintsPerReader : ""}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })
                        )}
                      </tbody>

                      {/* Footer Stats Summary */}
                      {filteredRecipients.length > 0 && (
                        <tfoot>
                          <tr>
                            <td colSpan="8"></td>
                            <td colSpan="8">
                              <div className={`d-flex justify-content-start py-2 ${"voting-section"}`}>
                                <label htmlFor="" className="mb-0 pt-2 me-2">
                                  {selectedLanguage.LstLanguageCodes.UI_Total} :
                                </label>
                                <label htmlFor="" className="mb-0 d-flex align-items-center me-2">
                                  <span className="material-icons me-2 colorGreen">
                                    thumb_up_alt
                                  </span>
                                  {enrichedRecipients.length > 0 ? enrichedRecipients.filter((bill) => bill.vote === 1).length : (item.documentOptions.recipients.length > 0 ? item.documentOptions.recipients.filter((bill) => bill.vote === 1).length : 0)}
                                </label>
                                <label htmlFor="" className="mb-0 d-flex align-items-center">
                                  <span className="material-icons me-2 colorRed">
                                    thumb_down_alt
                                  </span>
                                  {enrichedRecipients.length > 0 ? enrichedRecipients.filter((bill) => bill.vote === 0).length : (item.documentOptions.recipients.length > 0 ? item.documentOptions.recipients.filter((bill) => bill.vote === 0).length : 0)}
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  </div>

                  {/* Pagination Controls */}
                  {totalPages > 1 && (
                    <div className="d-flex align-items-center justify-content-between mt-3 px-1">
                      <span className="text-secondary font-13">
                        Showing {(popupCurrentPage - 1) * itemsPerPage + 1} to {Math.min(popupCurrentPage * itemsPerPage, filteredRecipients.length)} of {filteredRecipients.length} readers
                      </span>
                      <div className="d-flex align-items-center gap-1">
                        <button className="btn btn-sm btn-outline-secondary p-1 d-flex align-items-center justify-content-center"
                          disabled={popupCurrentPage === 1}
                          onClick={() => setPopupCurrentPage(p => Math.max(p - 1, 1))}
                        >
                          <span className="material-icons font-16">chevron_left</span>
                        </button>
                        <span className="mx-2 font-13 fw-semibold">Page {popupCurrentPage} of {totalPages}</span>
                        <button className="btn btn-sm btn-outline-secondary p-1 d-flex align-items-center justify-content-center"
                          disabled={popupCurrentPage === totalPages}
                          onClick={() => setPopupCurrentPage(p => Math.min(p + 1, totalPages))}
                        >
                          <span className="material-icons font-16">chevron_right</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {localIsReaderStatistics && AppContext.IsReaderStatsEnabled === true && localActiveEmail !== "" && localActiveEmail != undefined && (
        <div className="modalCus documentversion-history" id="myModal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="card-body pt-1 pb-0">
                <div className="mb-2 mt-3 justify-content-between d-flex" style={{ borderBottom: "2px solid #918d8d4d" }}>
                  <h4 className="fw-bold">
                    {selectedLanguage?.LstLanguageCodes?.UI_PagesReadAllSessions}
                  </h4>
                  <button type="button" className="btn btn-outline-danger modalclose download" onClick={handlecloseReaderStats}>
                    <span className="material-icons font-20">
                      highlight_off
                    </span>
                  </button>
                </div>
                <div className="card-body pt-0 " style={{ display: "block" }}>
                  <div className="table-responsive res-card" >
                    <div className="track-container mt-2">
                      <div className="d-flex justify-content-between align-items-center ">
                        <div className="Docnamewrap d-flex"><span className="fontWeight-500"> {selectedLanguage?.LstLanguageCodes?.UI_DocumentName}:</span> <span className="ms-1">{item.fileName}</span></div>
                        <div className=" d-flex"><span className="fontWeight-500"> {selectedLanguage?.LstLanguageCodes?.UI_DocumentID}:</span> <span className="ms-1">{item.documentId}</span></div>
                      </div>
                      <div className=" d-flex"><span className="fontWeight-500"> {selectedLanguage?.LstLanguageCodes?.UI_ReaderEmail}:</span ><span className="ms-1"> {localActiveEmail}</span></div>
                      <div className="reader-statis mt-2 d-flex justify-content-between align-items-center">
                        <div style={{ color: '#d21513' }} className="d-flex align-items-center ms-2">
                          <span className="material-icons me-1">stacked_bar_chart</span>
                          <span style={{ color: '#272d4efc' }}>{selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbyPage}</span>
                        </div>
                        <div className="position-relative number-search" style={{ maxWidth: "150px", flexShrink: 0, marginRight: '12px' }}>
                          <input type="search" className="form-control custom-inputBorder" placeholder={`${selectedLanguage?.LstLanguageCodes?.UI_PageNumber}...`} onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                            onChange={onSearchHandler}
                          />
                        </div>
                      </div>
                      <div className="d-flex border py-2 track-header">
                        <div className="flex-fill text-center w-25 text-wrap font-13 firefox-22">
                          {selectedLanguage?.LstLanguageCodes?.UI_PageNumber}
                        </div>
                        <div className="flex-fill text-center w-50 px-2 text-wrap font-13">
                          {selectedLanguage?.LstLanguageCodes?.UI_NumberOfUniqueReads}
                        </div>
                        <div className="flex-fill text-center w-25 px-2 text-wrap font-13">
                          {selectedLanguage?.LstLanguageCodes?.UI_TotalTimeViewed}
                          <ReactTooltip className="totalTime-tooltip" style={{ opacity: 1, }} anchorId={`timeFormat_${item.documentId}`} place="bottom">
                            <table className="tooltip-table">
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="d-flex flex-column p-1">
                                      <p className="statistics-tooltip-text mb-0">{selectedLanguage.LstLanguageCodes.UI_TotalTimeFormat}</p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </ReactTooltip>
                        </div>
                      </div>
                      <div className={`track-bodyscroll ${localTrackInteractivityData.length > 0 ? "" : "track-noBodyscroll"}`} style={{ maxHeight: "200px", overflowY: "auto" }}>
                        {localStatsLoading ? (
                          <div className="d-flex py-3 align-items-center justify-content-center">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : (() => {
                          const aggregatePageStats = (statsArray) => {
                            if (!Array.isArray(statsArray)) return [];
                            const map = {};
                            statsArray.forEach(stat => {
                              const page = stat.pageNumber;
                              const count = Number(stat.totalCount) || 0;
                              const h = Number(stat.totalHours) || 0;
                              const m = Number(stat.totalMinutes) || 0;
                              const s = Number(stat.totalSeconds) || 0;
                              const secs = (h * 3600) + (m * 60) + s;
                              const openRecId = stat.openRecordId;

                              if (!map[page]) {
                                map[page] = {
                                  pageNumber: page,
                                  totalCountSum: 0,
                                  uniqueSessions: new Set(),
                                  totalSecondsSum: 0
                                };
                              }
                              map[page].totalCountSum += count;
                              if (openRecId) {
                                map[page].uniqueSessions.add(openRecId);
                              }
                              map[page].totalSecondsSum += secs;
                            });

                            return Object.values(map).map(item => {
                              const totalHours = Math.floor(item.totalSecondsSum / 3600);
                              const totalMinutes = Math.floor((item.totalSecondsSum % 3600) / 60);
                              const totalSeconds = item.totalSecondsSum % 60;
                              const countVal = item.uniqueSessions.size > 0 ? item.uniqueSessions.size : item.totalCountSum;
                              return {
                                pageNumber: item.pageNumber,
                                totalCount: countVal,
                                totalHours,
                                totalMinutes,
                                totalSeconds
                              };
                            }).sort((a, b) => Number(a.pageNumber) - Number(b.pageNumber));
                          };

                          const aggregatedStats = aggregatePageStats(localTrackInteractivityData);
                          const filteredStats = aggregatedStats.filter(stat => {
                            if (!localSearchPageNum) return true;
                            return stat.pageNumber.toString().includes(localSearchPageNum);
                          });

                          if (filteredStats.length > 0) {
                            return filteredStats.map((openstatistics, l) => (
                              <div className="d-flex border-bottom py-1 align-items-center borderrow pe-3" key={l} >
                                <div className="flex-fill text-center w-25 text-wrap font-12">
                                  {openstatistics.pageNumber}
                                </div>
                                <div className="flex-fill text-center w-50 px-2 text-wrap font-12">
                                  {openstatistics.totalCount}
                                </div>
                                <div className="flex-fill text-center w-25 px-2 text-wrap font-12">
                                  {String(openstatistics.totalHours).padStart(2, "0")}:
                                  {String(openstatistics.totalMinutes).padStart(2, "0")}:
                                  {String(openstatistics.totalSeconds).padStart(2, "0")}
                                </div>
                              </div>
                            ));
                          }
                          else {
                            return (
                              <div className="d-flex py-3 align-items-center borderrow justify-content-center">
                                <span className="material-icons" style={{ fontSize: "18px", color: '#ff9800' }}>report_problem</span>
                                <span className="font-13 ms-2" style={{ fontWeight: '600' }}>  {selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                              </div>
                            );
                          }
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}